import { buildLocalizedHref, ROUTE_ALIASES } from '../../app/lib/routeUtils';
import { i18n } from '../../i18n-config';

// CMS slugs are language-specific. A translated path prefix does not prove that
// the corresponding article exists; only the server's verified links do.
export function buildLanguageLinks(locale, internalPath, query, verifiedLinks) {
  const isPrompt = /^solutions\/[^/]+$/.test(internalPath)
    && !Object.prototype.hasOwnProperty.call(ROUTE_ALIASES, internalPath);
  const isArticle = /^blog\/[^/]+$/.test(internalPath)
    && internalPath !== 'blog/author';
  const fallbackPath = isPrompt ? 'chatbot' : isArticle ? 'blog' : null;

  return Object.fromEntries(i18n.locales.map(lang => {
    if (verifiedLinks?.[lang]) return [lang, verifiedLinks[lang]];
    if (lang !== locale && fallbackPath) {
      return [lang, buildLocalizedHref(lang, fallbackPath)];
    }
    return [lang, buildLocalizedHref(lang, internalPath, query)];
  }));
}
